import { autoinject } from "aurelia-framework";

/**
 * Represents the footer of a toast.
 */
@autoinject
export class ToastFooterCustomElement
{
}
